'use strict'

import getSymbolFromCurrency from 'currency-symbol-map'

import {
	DURATIONS,
	PERIODS,
	SETUP,
	ATTENDEES,
	SALARIES
} from './constants'

export const calculateCost = ({ salary, duration, setup, period, attendees }) => {
	const hourlyRate = salary / 20 / 8
	const cost = (hourlyRate * ((duration + setup) / 60) * attendees).toFixed(2)
	const annualCost = (cost * period).toFixed(2)
	return { cost, annualCost }
}

export const currencySymbol = (currency) => {
	return getSymbolFromCurrency(currency) || '$'
}

export const customizeSelectTheme = (theme) => {
	return {
    ...theme,
    borderRadius: 0,
    colors: {
    	...theme.colors,
    	primary25: '#E1E0E0',
    	primary50: '#CECECE',
      primary: '#0C0503'
    }
  }
}

export const fixCurrencies = (currencies) => {
	delete currencies['ZWL']
	currencies['ZWD'] = 'Zimbabwean Dollar'
	return currencies
}

export const fixRates = (rates, toFix) => {
	toFix.forEach(obj => {
		const value = rates[obj.key]
		delete rates[obj.key]
		rates[obj.newKey] = value
	})

	return rates
}

export const getCurrencyName = (currencies, currency) => {
	if (currencies.hasOwnProperty(currency)) {
		return currencies[currency]
	}

	return ''
}

export const getSelectOptions = (option, currency) => {
	let options = []
	switch(option) {
		case 'duration':
			options = DURATIONS.map(obj => {
				return { label: obj.key, value: obj.value }
			})
			break
		case 'period':
			options = PERIODS.map(obj => {
				return { label: obj.key, value: obj.value }
			})
			break
		case 'setup':
			options = SETUP.map(obj => {
				return { label: obj.key, value: obj.value }
			})
			break
		case 'attendees':
			options = ATTENDEES.map(obj => {
				return { label: obj.key, value: obj.value }
			})
			break
		case 'salary':
			options = SALARIES.map(obj => {
				return { label: `${currencySymbol(currency)} ${obj.key}`, value: obj.value }
			})
			break
		default:
			break
	}

	return options
}

export const getSelectValue = (option, value) => {
	let selectValue = null
	switch(option) {
		case 'duration':
			selectValue = {
				label: DURATIONS.find(obj => obj.value === value).key,
				value
			}
			break
		case 'period':
			selectValue = {
				label: PERIODS.find(obj => obj.value === value).key,
				value
			}
			break
		case 'setup':
			selectValue = {
				label: SETUP.find(obj => obj.value === value).key,
				value
			}
			break
		case 'attendees':
			selectValue = {
				label: ATTENDEES.find(obj => obj.value === value).key,
				value
			}
			break
		case 'salary':
			selectValue = {
				label: SALARIES.find(obj => obj.value === value).key,
				value
			}
			break
		default:
			break
	}

	return selectValue
}

// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export const numberWithCommas = (number) => {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')
}

export const secondaryCurrencyCost = (cost, rates, fromCurrency, toCurrency) => {
	cost = parseFloat(cost)
	if (Object.keys(rates).length > 0) {
		const fromCurrencyRate = rates[fromCurrency]
		const toCurrenyRate = rates[toCurrency]
		return parseFloat((cost / fromCurrencyRate) * toCurrenyRate).toFixed(2)
	}

	return 0
}
